// extracted by mini-css-extract-plugin
export default {"DeleteClassificationTypesDialog":"DeleteClassificationTypesDialog_DeleteClassificationTypesDialog__rmsXy"};